var map = {
	"./acs-courier.svg": "./resources/assets/img/stores/acs-courier.svg",
	"./bonadiva/aisthisiaka-kallyntika-2x.jpg": "./resources/assets/img/stores/bonadiva/aisthisiaka-kallyntika-2x.jpg",
	"./bonadiva/aisthisiaka-kallyntika.jpg": "./resources/assets/img/stores/bonadiva/aisthisiaka-kallyntika.jpg",
	"./bonadiva/b1.jpg": "./resources/assets/img/stores/bonadiva/b1.jpg",
	"./bonadiva/b3.jpg": "./resources/assets/img/stores/bonadiva/b3.jpg",
	"./bonadiva/bdsm-2x.jpg": "./resources/assets/img/stores/bonadiva/bdsm-2x.jpg",
	"./bonadiva/bdsm.jpg": "./resources/assets/img/stores/bonadiva/bdsm.jpg",
	"./bonadiva/dildos-2x.jpg": "./resources/assets/img/stores/bonadiva/dildos-2x.jpg",
	"./bonadiva/dildos.jpg": "./resources/assets/img/stores/bonadiva/dildos.jpg",
	"./bonadiva/favicon-old.png": "./resources/assets/img/stores/bonadiva/favicon-old.png",
	"./bonadiva/favicon.png": "./resources/assets/img/stores/bonadiva/favicon.png",
	"./bonadiva/favicon.svg": "./resources/assets/img/stores/bonadiva/favicon.svg",
	"./bonadiva/free-shipping.png": "./resources/assets/img/stores/bonadiva/free-shipping.png",
	"./bonadiva/icon-11.png": "./resources/assets/img/stores/bonadiva/icon-11.png",
	"./bonadiva/logo-square.png": "./resources/assets/img/stores/bonadiva/logo-square.png",
	"./bonadiva/logo-white.png": "./resources/assets/img/stores/bonadiva/logo-white.png",
	"./bonadiva/logo.png": "./resources/assets/img/stores/bonadiva/logo.png",
	"./bonadiva/pattern.png": "./resources/assets/img/stores/bonadiva/pattern.png",
	"./bonadiva/phone.png": "./resources/assets/img/stores/bonadiva/phone.png",
	"./bonadiva/placeholder.png": "./resources/assets/img/stores/bonadiva/placeholder.png",
	"./bonadiva/play.png": "./resources/assets/img/stores/bonadiva/play.png",
	"./bonadiva/sfines-butt-plugs-2x.jpg": "./resources/assets/img/stores/bonadiva/sfines-butt-plugs-2x.jpg",
	"./bonadiva/sfines-butt-plugs.jpg": "./resources/assets/img/stores/bonadiva/sfines-butt-plugs.jpg",
	"./bonadiva/store-2x.jpg": "./resources/assets/img/stores/bonadiva/store-2x.jpg",
	"./bonadiva/store.jpg": "./resources/assets/img/stores/bonadiva/store.jpg",
	"./bonadiva/vibrators-2x.jpg": "./resources/assets/img/stores/bonadiva/vibrators-2x.jpg",
	"./bonadiva/vibrators.jpg": "./resources/assets/img/stores/bonadiva/vibrators.jpg",
	"./controls.png": "./resources/assets/img/stores/controls.png",
	"./deposit.png": "./resources/assets/img/stores/deposit.png",
	"./elta-courier.svg": "./resources/assets/img/stores/elta-courier.svg",
	"./favicon.svg": "./resources/assets/img/stores/favicon.svg",
	"./geniki-taxydromiki.svg": "./resources/assets/img/stores/geniki-taxydromiki.svg",
	"./icon-white.png": "./resources/assets/img/stores/icon-white.png",
	"./maestro.svg": "./resources/assets/img/stores/maestro.svg",
	"./mastercard-securecode.svg": "./resources/assets/img/stores/mastercard-securecode.svg",
	"./mastercard.svg": "./resources/assets/img/stores/mastercard.svg",
	"./medal.png": "./resources/assets/img/stores/medal.png",
	"./open-wisdom/cbd-oil-2x.jpg": "./resources/assets/img/stores/open-wisdom/cbd-oil-2x.jpg",
	"./open-wisdom/cbd-oil.jpg": "./resources/assets/img/stores/open-wisdom/cbd-oil.jpg",
	"./open-wisdom/favicon-old.png": "./resources/assets/img/stores/open-wisdom/favicon-old.png",
	"./open-wisdom/favicon.png": "./resources/assets/img/stores/open-wisdom/favicon.png",
	"./open-wisdom/favicon.svg": "./resources/assets/img/stores/open-wisdom/favicon.svg",
	"./open-wisdom/free-shipping.png": "./resources/assets/img/stores/open-wisdom/free-shipping.png",
	"./open-wisdom/header.png": "./resources/assets/img/stores/open-wisdom/header.png",
	"./open-wisdom/icon-11.png": "./resources/assets/img/stores/open-wisdom/icon-11.png",
	"./open-wisdom/icon.png": "./resources/assets/img/stores/open-wisdom/icon.png",
	"./open-wisdom/logo-square.png": "./resources/assets/img/stores/open-wisdom/logo-square.png",
	"./open-wisdom/logo-white.png": "./resources/assets/img/stores/open-wisdom/logo-white.png",
	"./open-wisdom/logo.png": "./resources/assets/img/stores/open-wisdom/logo.png",
	"./open-wisdom/open-wisdom-1.jpg": "./resources/assets/img/stores/open-wisdom/open-wisdom-1.jpg",
	"./open-wisdom/open-wisdom-2.jpg": "./resources/assets/img/stores/open-wisdom/open-wisdom-2.jpg",
	"./open-wisdom/open-wisdom-3.jpg": "./resources/assets/img/stores/open-wisdom/open-wisdom-3.jpg",
	"./open-wisdom/peripoiisi-mallion-2x.jpg": "./resources/assets/img/stores/open-wisdom/peripoiisi-mallion-2x.jpg",
	"./open-wisdom/peripoiisi-mallion.jpg": "./resources/assets/img/stores/open-wisdom/peripoiisi-mallion.jpg",
	"./open-wisdom/peripoiisi-prosopou-2x.jpg": "./resources/assets/img/stores/open-wisdom/peripoiisi-prosopou-2x.jpg",
	"./open-wisdom/peripoiisi-prosopou.jpg": "./resources/assets/img/stores/open-wisdom/peripoiisi-prosopou.jpg",
	"./open-wisdom/phone.png": "./resources/assets/img/stores/open-wisdom/phone.png",
	"./open-wisdom/placeholder.png": "./resources/assets/img/stores/open-wisdom/placeholder.png",
	"./open-wisdom/play.png": "./resources/assets/img/stores/open-wisdom/play.png",
	"./open-wisdom/seminars-2x.jpg": "./resources/assets/img/stores/open-wisdom/seminars-2x.jpg",
	"./open-wisdom/seminars.jpg": "./resources/assets/img/stores/open-wisdom/seminars.jpg",
	"./open-wisdom/seminars/header-1.jpg": "./resources/assets/img/stores/open-wisdom/seminars/header-1.jpg",
	"./open-wisdom/seminars/header-2.jpg": "./resources/assets/img/stores/open-wisdom/seminars/header-2.jpg",
	"./open-wisdom/seminars/sensities-seminars-center.jpg": "./resources/assets/img/stores/open-wisdom/seminars/sensities-seminars-center.jpg",
	"./open-wisdom/set-proionton-kannavis-2x.jpg": "./resources/assets/img/stores/open-wisdom/set-proionton-kannavis-2x.jpg",
	"./open-wisdom/set-proionton-kannavis.jpg": "./resources/assets/img/stores/open-wisdom/set-proionton-kannavis.jpg",
	"./open-wisdom/store-2x.jpg": "./resources/assets/img/stores/open-wisdom/store-2x.jpg",
	"./open-wisdom/store.jpg": "./resources/assets/img/stores/open-wisdom/store.jpg",
	"./paypal.svg": "./resources/assets/img/stores/paypal.svg",
	"./piraeus.svg": "./resources/assets/img/stores/piraeus.svg",
	"./safari-pinned-tab.svg": "./resources/assets/img/stores/safari-pinned-tab.svg",
	"./sensities/aitheria-elaia.jpg": "./resources/assets/img/stores/sensities/aitheria-elaia.jpg",
	"./sensities/apple-touch-icon.png": "./resources/assets/img/stores/sensities/apple-touch-icon.png",
	"./sensities/essential-oils-2x.jpg": "./resources/assets/img/stores/sensities/essential-oils-2x.jpg",
	"./sensities/essential-oils.jpg": "./resources/assets/img/stores/sensities/essential-oils.jpg",
	"./sensities/favicon-old.png": "./resources/assets/img/stores/sensities/favicon-old.png",
	"./sensities/favicon.png": "./resources/assets/img/stores/sensities/favicon.png",
	"./sensities/favicon.svg": "./resources/assets/img/stores/sensities/favicon.svg",
	"./sensities/free-shipping.png": "./resources/assets/img/stores/sensities/free-shipping.png",
	"./sensities/fytika-kallyntika-2x.jpg": "./resources/assets/img/stores/sensities/fytika-kallyntika-2x.jpg",
	"./sensities/fytika-kallyntika.jpg": "./resources/assets/img/stores/sensities/fytika-kallyntika.jpg",
	"./sensities/header.png": "./resources/assets/img/stores/sensities/header.png",
	"./sensities/icon.png": "./resources/assets/img/stores/sensities/icon.png",
	"./sensities/kallyntika.jpg": "./resources/assets/img/stores/sensities/kallyntika.jpg",
	"./sensities/logo-square.png": "./resources/assets/img/stores/sensities/logo-square.png",
	"./sensities/logo-white.png": "./resources/assets/img/stores/sensities/logo-white.png",
	"./sensities/logo.png": "./resources/assets/img/stores/sensities/logo.png",
	"./sensities/phone.png": "./resources/assets/img/stores/sensities/phone.png",
	"./sensities/placeholder.png": "./resources/assets/img/stores/sensities/placeholder.png",
	"./sensities/play.png": "./resources/assets/img/stores/sensities/play.png",
	"./sensities/protes-yles-kallyntikon-2x.jpg": "./resources/assets/img/stores/sensities/protes-yles-kallyntikon-2x.jpg",
	"./sensities/protes-yles-kallyntikon.jpg": "./resources/assets/img/stores/sensities/protes-yles-kallyntikon.jpg",
	"./sensities/seminars-2x.jpg": "./resources/assets/img/stores/sensities/seminars-2x.jpg",
	"./sensities/seminars.jpg": "./resources/assets/img/stores/sensities/seminars.jpg",
	"./sensities/seminars/header-1.jpg": "./resources/assets/img/stores/sensities/seminars/header-1.jpg",
	"./sensities/seminars/header-2.jpg": "./resources/assets/img/stores/sensities/seminars/header-2.jpg",
	"./sensities/seminars/sensities-seminars-center.jpg": "./resources/assets/img/stores/sensities/seminars/sensities-seminars-center.jpg",
	"./sensities/store-2x.jpg": "./resources/assets/img/stores/sensities/store-2x.jpg",
	"./sensities/store.jpg": "./resources/assets/img/stores/sensities/store.jpg",
	"./sensities/votana.jpg": "./resources/assets/img/stores/sensities/votana.jpg",
	"./sensities/votanotherapeia-2x.jpg": "./resources/assets/img/stores/sensities/votanotherapeia-2x.jpg",
	"./sensities/votanotherapeia.jpg": "./resources/assets/img/stores/sensities/votanotherapeia.jpg",
	"./shipping.png": "./resources/assets/img/stores/shipping.png",
	"./tracking.png": "./resources/assets/img/stores/tracking.png",
	"./verified-by-visa.svg": "./resources/assets/img/stores/verified-by-visa.svg",
	"./visa.svg": "./resources/assets/img/stores/visa.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/assets/img/stores sync recursive \\.(png|jpe?g|gif|svg)$";